import React, { useEffect, useState } from "react";
import axios from "axios";
import Card from "./Card";
import Pagination from "./Pagination";
import TopFilterBar from "./TopFilterBar";
import "../Home/Inventory.css";

const AllCars = () => {
  const [cars, setCars] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 15;

  useEffect(() => {
    axios
      .get(`https://automotive-backend-production.up.railway.app/inventory?page=${page}&limit=${limit}`)
      .then((res) => {
        setCars(res.data.cars || []);
        setTotalCount(res.data.totalCount || 0);
      })
      .catch((err) => console.error(err));
  }, [page]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <div className="container my-4">
      {/* Top Filter Bar */}
      <TopFilterBar />
      <div className="inventory-header">
        <h4>Inventory</h4>
      </div>
      <div className="row g-3">
        {cars.map((car) => {
          // ✅ Use Thumbnail if available, otherwise fallback to ImageURL or placeholder
          const carImage = car.Thumbnail
            ? `https://automotive-backend-production.up.railway.app/${car.Thumbnail}`
            : car.ImageURL?.[0]
            ? `https://automotive-backend-production.up.railway.app/${car.ImageURL[0]}`
            : "https://via.placeholder.com/300x200?text=No+Image";

          return (
            <div key={car._id} className="col-md-6 col-lg-4">
              <Card
                id={car._id}
                image={carImage}
                price={`${car.Price}`}
                title={car.Name}
                year={car.Year}
                transmission={car.Transmission}
                fuel={car.FuelType}
                km={car.Mileage}
                RecordNumber={car.RecordNumber}
              />
            </div>
          );
        })}
      </div>
      <Pagination
        page={page}
        onPageChange={handlePageChange}
        totalCount={totalCount}
        limit={limit}
      />
    </div>
  );
};

export default AllCars;
